import api from "../api";

const endpoint = {
    fetchCategories: () => {
        return api.get("/category/list")
    }
}

export default endpoint;